import * as React from 'react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from '@mui/material';

interface DaysOfWeekCheckboxesProps {
  label: string;
  value: string;
  onChange: Function;
}

export const DaysOfWeekCheckboxes: React.FC<DaysOfWeekCheckboxesProps> = (props: DaysOfWeekCheckboxesProps) => {
  const { label, value, onChange = () => {} } = props;
  const [days, setDays] = React.useState([
    false, // 0 - sunday
    true, // 1 - monday
    true, // 2 - tuesday
    true, // 3 - wednesday
    true, // 4 - thursday
    true, // 5 - friday
    false, // 6 - saturday
  ]);

  // load initial value
  React.useEffect(() => {
    const activeDays = stringToDays(value);
    setDays(activeDays);
  }, []);

  React.useEffect(() => {
    const value = daysToString(days);
    onChange(value);
  }, [days]);

  const stringToDays = (string: string) => {
    return days.map((v, i) => string.includes(String(i)));
  };

  const daysToString = (days: boolean[]) => {
    return days
      .map((checked, index) => (checked ? index : null))
      .filter((v) => v !== null)
      .join(',');
  };

  const handleCheckboxToggle = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const updatedDays = days.map((checked, i) => {
      return i === index ? event.target.checked : checked;
    });
    setDays(updatedDays);
  };

  return (
    <FormControl component="fieldset" sx={{ width: '100%' }}>
      <FormLabel component="legend">{label}</FormLabel>
      <FormGroup aria-label="position" row sx={{ justifyContent: 'space-between' }}>
        <FormControlLabel
          control={<Checkbox checked={days[0]} onChange={(event) => handleCheckboxToggle(event, 0)} />}
          label="S"
          labelPlacement="bottom"
          sx={{ m: 0 }}
        />
        <FormControlLabel
          control={<Checkbox checked={days[1]} onChange={(event) => handleCheckboxToggle(event, 1)} />}
          label="M"
          labelPlacement="bottom"
          sx={{ m: 0 }}
        />
        <FormControlLabel
          control={<Checkbox checked={days[2]} onChange={(event) => handleCheckboxToggle(event, 2)} />}
          label="T"
          labelPlacement="bottom"
          sx={{ m: 0 }}
        />
        <FormControlLabel
          control={<Checkbox checked={days[3]} onChange={(event) => handleCheckboxToggle(event, 3)} />}
          label="W"
          labelPlacement="bottom"
          sx={{ m: 0 }}
        />
        <FormControlLabel
          control={<Checkbox checked={days[4]} onChange={(event) => handleCheckboxToggle(event, 4)} />}
          label="TH"
          labelPlacement="bottom"
          sx={{ m: 0 }}
        />
        <FormControlLabel
          control={<Checkbox checked={days[5]} onChange={(event) => handleCheckboxToggle(event, 5)} />}
          label="F"
          labelPlacement="bottom"
          sx={{ m: 0 }}
        />
        <FormControlLabel
          control={<Checkbox checked={days[6]} onChange={(event) => handleCheckboxToggle(event, 6)} />}
          label="SA"
          labelPlacement="bottom"
          sx={{ m: 0 }}
        />
      </FormGroup>
    </FormControl>
  );
};
